import Grid from '@material-ui/core/Grid';
import { createStyles, makeStyles, Theme, ThemeOptions } from '@material-ui/core';
import moment from 'moment';
import React from 'react';

import { baseTheme } from '../../../../../theme';
import { KeyboardDatePicker } from '@material-ui/pickers';

interface IPostComponentProps {
  date: number;
  setSelectedDate: Function;
  postType?: string | undefined;
  disabled?: boolean | undefined;
}

const toolBarColorPicker = (typeResolver: string | undefined) => {
  return typeResolver === 'Public'
    ? 'rgba(65, 0, 153, 1.0)'
    : typeResolver === 'Private'
      ? 'rgba(0, 101, 207, 1.0)'
      : 'rgba(0, 0, 0, 1.0)';
};

const useStyles = (
  theme: ThemeOptions,
  typeResolver: string | undefined) =>
  makeStyles((theme: Theme) =>
    createStyles({
      root: {
        '& .MuiIconButton-root': {
          color: toolBarColorPicker(typeResolver),
        },
      },
      publicColor: {
        color: theme.palette.primary.main,
      },
      privateColor: {
        color: theme.palette.secondary.main,
      },
      staticColor: {
        color: theme.palette.text.primary,
      },
    }),
  );

export default function PostDatePicker(props: IPostComponentProps) {
  const { date, setSelectedDate, postType = undefined , disabled = false } = props;
  const classes = useStyles(baseTheme, postType)();

  const handleChange = (date: any) => {
    const stringDate = moment(date).toString();
    if (stringDate !== 'Invalid date') {
      setSelectedDate(stringDate);
    }
  };

  return (
      <Grid
        item
        container
        direction="column"
        className={`${classes.root}`}
      >
          <KeyboardDatePicker
            autoOk
            variant="inline"
            inputVariant="outlined"
            format="MM/dd/yyyy"
            value={date}
            InputAdornmentProps={{ position: 'start' }}
            onChange={handleChange}
            placeholder="Format: MM/DD/YYYY"
            size="small"
            disabled={disabled}
          ></KeyboardDatePicker>
        </Grid>
  );
}
